<template>
  <div class="component-time-line-item">
    <div class="component-time-line-item-row">
      <van-icon :name="icon" />
      <div class="component-time-line-item-time">{{ time }}</div>
    </div>
    <div class="component-time-line-item-content">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'TimeLineItem',
  props: {
    icon: {
      type: String,
      default: 'clock'
    },
    time: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss">
.component-time-line-item {
  .component-time-line-item-row {
    align-items: center;
    display: flex;
    .van-icon {
      color: #0761F3;
      font-size: 28px;
    }
    .component-time-line-item-time {
      color: #242424;
      font-size: 34px;
      font-weight: 500;
      margin-left: 12px;
      height: 48px;
      line-height: 48px;
    }
  }
  .component-time-line-item-content {
    margin-top: 24px;
    padding-left: 32px;
    padding-bottom: 36px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TimeLine/Item.vue